import { useMemo } from 'react';
import styled from 'styled-components';
import { Dropdown } from '../../Dropdown';
import { DropdownContentContainer } from '../../DropdownContentContainer';
import { NumberInput } from '../../baseInputs/NumberInput';
import { useScene } from '../../../../context/sceneContext';

export const MarginInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    { margin: undefined, marginTop: 0, marginBottom: 0, marginLeft: 0, marginRight: 0 },
    'props.class'
  );

  const mainInputValue = useMemo(
    () =>
      data.marginTop === data.marginBottom &&
      data.marginBottom === data.marginLeft &&
      data.marginLeft === data.marginRight
        ? data.marginTop
        : undefined,
    [data]
  );

  return (
    <Row>
      <NumberInput
        iconClassName="icon-margin"
        id={'margin-input'}
        tooltip="Margin"
        value={mainInputValue}
        onChange={(newValue) =>
          scene.updateSelectedElementsData(
            {
              margin: undefined,
              marginTop: newValue,
              marginBottom: newValue,
              marginLeft: newValue,
              marginRight: newValue,
            },
            'props.class',
            'marginInput'
          )
        }
        precision={0}
        minValue={0}
        defaultUnit="px"
        inputStyle={{ textAlign: 'center', marginRight: '16px' }}
        placeholder="mixed"
      />
      <Dropdown
        trigger={
          <DropdownButton>
            <i className="icon-triple-dots" />
          </DropdownButton>
        }
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          width: '16px',
          height: '100%',
        }}
        horizontalAlign="center"
        closeOnClick={false}
      >
        <DropdownContentContainer>
          <Title>Margin</Title>
          <Row>
            <Icon className="icon-border-all" />
            <Label>All</Label>
            <NumberInput
              value={mainInputValue}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    margin: undefined,
                    marginTop: newValue,
                    marginBottom: newValue,
                    marginLeft: newValue,
                    marginRight: newValue,
                  },
                  'props.class',
                  'marginInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
              placeholder="mixed"
            />
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '180deg' }} />
            <Label>Top</Label>
            <NumberInput
              value={data.marginTop}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    margin: undefined,
                    marginTop: newValue,
                  },
                  'props.class',
                  'marginInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Icon className="icon-border" />
            <Label>Bottom</Label>
            <NumberInput
              value={data.marginBottom}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    margin: undefined,
                    marginBottom: newValue,
                  },
                  'props.class',
                  'marginInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '90deg' }} />
            <Label>Left</Label>
            <NumberInput
              value={data.marginLeft}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    margin: undefined,
                    marginLeft: newValue,
                  },
                  'props.class',
                  'marginInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
          <Row>
            <Icon className="icon-border" style={{ rotate: '-90deg' }} />
            <Label>Right</Label>
            <NumberInput
              value={data.marginRight}
              onChange={(newValue) =>
                scene.updateSelectedElementsData(
                  {
                    margin: undefined,
                    marginRight: newValue,
                  },
                  'props.class',
                  'marginInput'
                )
              }
              precision={0}
              minValue={0}
              defaultUnit="px"
              inputStyle={{ textAlign: 'center' }}
            />
          </Row>
        </DropdownContentContainer>
      </Dropdown>
    </Row>
  );
};

const Row = styled.div`
  position: relative;
  width: 100%;
  display: flex;

  gap: 5px;
`;

const DropdownButton = styled.div`
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 5px;

  & > i {
    rotate: 90deg;
    font-size: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  transition:
    background-color 0.2s,
    color 0.2s;
  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }
`;

const Icon = styled.i`
  font-size: 15px;
  width: 22px;
  height: 22px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
const Label = styled.div`
  width: 100px;
  heigth: 22px;

  font-size: 11px;
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  text-align: center;
  font-size: 12px;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--neutral-3);
`;
